import { useLayoutEffect, useRef } from "react";
import "./HomeToProjects.css";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function HomeToProjects() {
  const navigate = useNavigate();
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".cta-kicker", {
        y: 20, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: rootRef.current, start: "top 82%" },
      });
      gsap.from(".cta-title .word", {
        yPercent: 110, duration: 0.9, stagger: 0.08, ease: "expo.out",
        scrollTrigger: { trigger: ".cta-title", start: "top 85%" },
      });
      gsap.from(".cta-sub", {
        y: 16, opacity: 0, duration: 0.6, delay: 0.15, ease: "power3.out",
        scrollTrigger: { trigger: ".cta-sub", start: "top 88%" },
      });
      gsap.from(".cta-actions .btn", {
        y: 20, opacity: 0, duration: 0.6, stagger: 0.08, ease: "power3.out",
        scrollTrigger: { trigger: ".cta-actions", start: "top 90%" },
      });
      // parallax bg
      gsap.to(".cta-bg-orb", {
        y: -60, ease: "none",
        scrollTrigger: { trigger: rootRef.current, start: "top bottom", end: "bottom top", scrub: true },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="home-cta">
      <div className="cta-bg" aria-hidden>
        <div className="cta-bg-orb cta-bg-orb--1" />
        <div className="cta-bg-orb cta-bg-orb--2" />
        <div className="cta-grid" />
      </div>

      <div className="cta-inner">
        <span className="cta-kicker eyebrow">Selected work</span>
        <h2 className="cta-title">
          <span className="word-wrap"><span className="word">Check out</span></span>
          <span className="word-wrap"><span className="word">the projects <em>I've</em></span></span>
          <span className="word-wrap"><span className="word grad-text">worked on</span></span>
        </h2>
        <p className="cta-sub">From human-rights platforms to consumer apps — 7 production projects across web & mobile.</p>
        <div className="cta-actions">
          <button className="btn btn-primary" onClick={() => navigate("/projects")}>
            See my projects <span className="btn-arrow">→</span>
          </button>
          <button className="btn btn-ghost" onClick={() => navigate("/contact")}>
            Start a project
          </button>
        </div>
      </div>
    </section>
  );
}
